import { t } from "i18next";
import { config } from "../config";
import { DataType } from "../models/models";

export function halve(x, isFirst: boolean) {
    if (isFirst)
        return x.filter((i, idx) => idx < Math.ceil(x.length / 2))
    else
        return x.filter((i, idx) => idx >= Math.ceil(x.length / 2))
}

export function extractLessonUrls(data) {
    let tempUrls = [];

    data = JSON.parse(data)['data'];

    if (data['background']) {
        if (data['background'].dataType == DataType.video) {
            tempUrls.push(data['background'].dataUrl);
        }
    }

    for (let i = 0; i < data['widgets'].length; i++) {
        let parsedW = data['widgets'][i];
        if (parsedW.dataType == DataType.video) {
            tempUrls.push(parsedW.dataUrl);
        }
    }

    return tempUrls;
}

export async function extractUrls(auth) {
    let urls = [];

    let data = await auth.getDownloadableLessons(config.isMiri(), config.isMiriPro());

    for (let i = 0; i < data.data.length; i++) {
        let lesson = data.data[i];

        let tempUrls = extractLessonUrls(lesson['content']);
        urls = urls.concat(tempUrls);
    }

    return urls;
}

export function getErrorMsgFromCode(code: string, fallback: string) {
    switch (+code) {
        case 100:
            return t('usernameOrPasswordWrong');
        case 200:
            return t('userNotAllowed');
        case 400:
            return t('noLauncher');
        case 600:
            return t('genericError');
        case 700:
            return t('noActiveLicensePresent');
    }

    return fallback;
}

export function rgbToHex(rgb) {
    // Estrai i numeri dal formato "rgb(87, 144, 171)"
    const match = rgb.match(/\d+/g);
    if (!match || match.length < 3) return null; // Se non è un valore RGB valido

    const r = parseInt(match[0]).toString(16).padStart(2, "0");
    const g = parseInt(match[1]).toString(16).padStart(2, "0");
    const b = parseInt(match[2]).toString(16).padStart(2, "0");

    return `#${r}${g}${b}`.toUpperCase();
  }